import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Form, Row, Col, Table, Pagination } from 'react-bootstrap';
import apiClient from "../../../api/apiClient";
import { GETROLEWISEREPORT, DOWNLOADUSERWISEREPORT, GETROLEWISEREPORTSUMMARY, GETCOURSEWISEREPORT, USERCOURSEPROGERSSCOURSEWISE } from '../../../utils/ApiEndPoint';
import { DownLoadFromUrl, downloadFromData } from '../../../utils/utils';
import { DownLoadExcelReportIcon, TotalCoursesIcon, CompleteIcon, InprocessCoursesIcon, PendingCoursesIcon } from '../../../utils/FontIcon';
import { Input } from "../../shared";


export default function Rolewisetracking() {
    const [reportData, setReportData] = useState([]);
    const [rollwiseSummary, setRollwiseSummary] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [reportType, setReportType] = useState('01');
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    });
    const pageSize = 10;
    useEffect(() => {
        apiClient.get(GETROLEWISEREPORTSUMMARY)
            .then((response) => {
                if (response.status === 200) {
                    setRollwiseSummary(response.data)
                }
            }).catch((error) => {

            }).finally(() => {

            });
        GetRollWiseReport();
    }, []);
    useEffect(() => {
        if (reportType === '01') {
            GetRollWiseReport();
        } else if (reportType === '02') {
            GetCourseWiseReport();
        }
    }, [reportType]);

    const GetRollWiseReport = () => {
        apiClient.get(GETROLEWISEREPORT)
            .then((response) => {
                if (response.status === 200) {
                    setReportData(response.data)
                }

            }).catch((error) => {

            }).finally(() => {

            });
    }
    const GetCourseWiseReport = () => {
        apiClient.get(GETCOURSEWISEREPORT)
            .then((response) => {
                if (response.status === 200) {
                    setReportData(response.data)
                }

            }).catch((error) => {

            }).finally(() => {

            });
    }
    const downLoadReport = (rollName) => {
        DownLoadFromUrl(`${DOWNLOADUSERWISEREPORT}/${rollName}?format=csv`);
    }
    const paginatedItem = useMemo(() => {
        return reportData.slice(
            (currentPage - 1) * pageSize,
            currentPage * pageSize
        );
    }, [reportData, currentPage]);
    const totalPages = Math.ceil(reportData.length / pageSize);
    const handlePageChange = useCallback((pageNumber) => {
        setCurrentPage(pageNumber);
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setReportType(value);
    };
    const exportCourWiseData = () => {
        apiClient.get(USERCOURSEPROGERSSCOURSEWISE)
            .then((response) => {
                if (response.status === 200) {
                    downloadFromData(response.data, `course-wise-progress-${new Date().toISOString()}.csv`, 'text/csv');
                } else {
                    setShowAlert({
                        type: 'danger',
                        title: 'Error',
                        msg: 'Failed to export course-wise progress report',
                        show: true
                    });
                }
            }).catch(() => {
                setShowAlert({
                    type: 'danger',
                    title: 'Error',
                    msg: 'Failed to export user data',
                    show: true
                });
            });
    }
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    return (
        <>
            <Row className='justify-content-center align-items-center'>
                <Col sm={12} className="count-card-bg">
                    <Row>
                        <Col lg={3} className="summary-container">
                            <span style={{ fontWeight: '600', fontSize: '1.35rem' }}>Tracking Overview</span>
                            <span className="summary-txt">Summary</span>

                        </Col>
                        <Col lg={9}>
                            <Row>
                                <Col lg={3} xs={6}>
                                    <div className="count-card-container total">
                                        <span className="count-card-icon total-icon" aria-label="Total Enrolled Icon"><TotalCoursesIcon /></span>
                                        <span className="count-no" aria-label="Total Enrolled Count">{rollwiseSummary?.totalCourses || 0}</span>
                                        <span className="fs-small12">Total Enrolled</span>
                                    </div></Col>
                                <Col lg={3} xs={6}>
                                    <div className="count-card-container complete">
                                        <span className="count-card-icon complete-icon" aria-label="Completed Course Icon"><CompleteIcon /></span>
                                        <span className="count-no" aria-label="Completed Course Count">{rollwiseSummary?.totalCompleted || 0}</span>
                                        <span className="fs-small12">Completed</span>
                                    </div>
                                </Col>
                                <Col lg={3} xs={6}>
                                    <div className="count-card-container inprocess">
                                        <span className="count-card-icon inprocess-icon" aria-label="Inprocess Course Icon"><InprocessCoursesIcon /></span>
                                        <span className="count-no" aria-label="Inprocess Course Count">{rollwiseSummary?.totalInProgress || 0}</span>
                                        <span className="fs-small12">In-Progress</span>
                                    </div>
                                </Col>
                                <Col lg={3} xs={6}>
                                    <div className="count-card-container pending">
                                        <span className="count-card-icon pending-icon" aria-label="Pending Course Icon"><PendingCoursesIcon /></span>
                                        <span className="count-no" aria-label="Pending Course Count">{rollwiseSummary?.totalPending || 0}</span>
                                        <span className="fs-small12">Pending</span>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='mt-3'>
                <Col md={4} sm={12} className='mb-3'>
                    <Input
                        label="Report Type"
                        isMandetory={false}
                        name="reportType"
                        type="select"
                        value={reportType}
                        onChange={handleChange}
                        multiple={false}
                        options={[{ value: '01', label: 'Role-wise' }, { value: '02', label: 'Course-wise' }]}
                    />
                </Col>
            </Row>
            <Row className='justify-content-center align-items-center'>
                <Col sm={12} >
                    <Row>
                        <Col sm={9}>
                            <h6 className='fw-700 mt-3 mb-3'>Course Learning Tracking - ({reportType === '01' ? 'Role-wise' : 'Course-wise'})</h6>
                        </Col>
                        {reportType === '02' && (


                            <Col sm={3} className='d-flex justify-content-end'>
                                <button className="btn btn-sm btn-success" onClick={exportCourWiseData}>
                                    <DownLoadExcelReportIcon style={{ width: '16px', height: '16px', marginRight: '5px' }} /> Download
                                </button>
                            </Col>
                        )}
                    </Row>
                </Col>
                <Col sm={12}>
                    {reportType === '02' ? <Table responsive className='mytable'>
                        <thead >
                            <tr>
                                <th scope="col" className='txt-center'>S.No.</th>
                                <th scope="col" className="text-start">Course Name</th>
                                <th scope="col" className='txt-center'>Total Enrolled</th>
                                <th scope="col" className='txt-center'>Completed</th>
                                <th scope="col" className='txt-center'>In-Progress</th>
                                <th scope="col" className='txt-center'>Pending</th>
                                {/* <th scope="col" className='txt-center'>Download</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedItem.map((item, idx) => {
                                return <tr key={idx + (currentPage - 1) * pageSize}>
                                    <td className='txt-center'> {(currentPage - 1) * pageSize + idx + 1}</td>
                                    <td className='text-start'>{item.courseName}</td>
                                    <td className='txt-center'>{item.totalUsers}</td>
                                    <td className='txt-center'>{item.totalCompleted}</td>
                                    <td className='txt-center'>{item.totalInProgress}</td>
                                    <td className='txt-center'>{item.totalPending}</td>
                                    {/* <td className='txt-center'> <a onClick={() => {
                                    downLoadReport(item.courseName)
                                }} style={{ cursor: 'pointer' }} title="Download"><DownLoadExcelReportIcon /></a></td> */}
                                </tr>
                            })}
                        </tbody>
                    </Table> :

                        <Table responsive className='mytable'>
                            <thead >
                                <tr>
                                    <th scope="col" className='txt-center'>S.No.</th>
                                    <th scope="col" className="text-start">Role Name</th>
                                    <th scope="col" className='txt-center'>Total Course</th>
                                    <th scope="col" className='txt-center'>Completed</th>
                                    <th scope="col" className='txt-center'>In-Progress</th>
                                    <th scope="col" className='txt-center'>Pending</th>
                                    <th scope="col" className='txt-center'>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedItem.map((item, idx) => {
                                    return <tr key={idx + (currentPage - 1) * pageSize}>
                                        <td className='txt-center'> {(currentPage - 1) * pageSize + idx + 1}</td>
                                        <td className='text-start'>{item.roleName}</td>
                                        <td className='txt-center'>{item.totalCourses}</td>
                                        <td className='txt-center'>{item.totalCompleted}</td>
                                        <td className='txt-center'>{item.totalInProgress}</td>
                                        <td className='txt-center'>{item.totalPending}</td>
                                        <td className='txt-center'> <a onClick={() => {
                                            downLoadReport(item.roleName)
                                        }} style={{ cursor: 'pointer' }} title="Download"><DownLoadExcelReportIcon /></a></td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    }
                </Col>
                <Col sm={12}>
                    <div className="d-flex justify-content-center">
                        <Pagination className='mypagination-listing'>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                            {[...Array(totalPages)].map((_, idx) => (
                                <Pagination.Item
                                    key={idx + 1}
                                    active={currentPage === idx + 1}
                                    onClick={() => handlePageChange(idx + 1)}
                                >
                                    {idx + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>
                    </div>
                </Col>
            </Row>
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
        </>
    );
}